import { useTranslation } from 'react-i18next';
import {
	Typography,
	Card,
	CardContent,
	Stack,
	Button,
	Box,
	Tabs,
	Tab,
} from '@mui/material';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PreAdmissionSummaryPage from '../pre-admission/PreAdmissionSummaryPage';
import { PermissionEnum, PreAdmissionTab } from '@/api/enum/common.enum';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useGetUser } from '@/hooks/useGetUser';

interface Props {
	preAdmissionTab: PreAdmissionTab;
}

export default function PreAdmissionProgressSummaryPage(props: Props) {
	const { preAdmissionTab } = props;
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { userInfo } = useGetUser();

	const [currentTab, setCurrentTab] = useState(preAdmissionTab);

	const handleTabChange = (
		event: React.SyntheticEvent,
		newValue: PreAdmissionTab
	) => {
		setCurrentTab(newValue);
	};

	return (
		<>
			<Box display='flex' justifyContent='space-between'>
				<Typography variant='h4'>
					{t('drawerListItems.preAdmissionList')}
				</Typography>
				<Stack direction={'row'} alignItems={'center'} spacing={3}>
					{userInfo?.permissionList?.includes(
						PermissionEnum.CreatePreAdmission
					) && (
						<Button
							sx={{ textTransform: 'none' }}
							variant='contained'
							endIcon={<AddCircleOutlineIcon />}
							onClick={() =>
								navigate(`/pre-admission/pre-admission-list/create`)
							}
							style={{ alignItems: 'center' }}
						>
							{t('drawerListItems.newPreAdmission')}
						</Button>
					)}
				</Stack>
			</Box>

			<Card sx={{ marginTop: 3 }}>
				<CardContent>
					<Tabs
						value={currentTab}
						onChange={handleTabChange}
						sx={{ marginBottom: '16px' }}
					>
						<Tab
							sx={{ textTransform: 'none' }}
							label={
								<Typography variant='body1'>
									{t('preAdmission.inProgress')}
								</Typography>
							}
							value={PreAdmissionTab.progress}
							to='/pre-admission/pre-admission-list'
							component={Link}
						/>
						<Tab
							sx={{ textTransform: 'none' }}
							label={
								<Typography variant='body1'>
									{t('preAdmission.submitted')}
								</Typography>
							}
							value={PreAdmissionTab.submitted}
							to='/pre-admission/pre-admission-list/submitted'
							component={Link}
						/>
						<Tab
							sx={{ textTransform: 'none' }}
							label={
								<Typography variant='body1'>
									{t('preAdmission.notSuitable')}
								</Typography>
							}
							value={PreAdmissionTab.notSuitable}
							to='/pre-admission/pre-admission-list/not-suitable'
							component={Link}
						/>
						<Tab
							sx={{ textTransform: 'none' }}
							label={
								<Typography variant='body1'>{t('preAdmission.all')}</Typography>
							}
							value={PreAdmissionTab.all}
							to='/pre-admission/pre-admission-list/all'
							component={Link}
						/>
					</Tabs>
					<PreAdmissionSummaryPage preAdmissionTab={currentTab} />
				</CardContent>
			</Card>
		</>
	);
}
